<template>
  <div class="extrageneticDirectories">
    <div class="navbar">
      <img src="@/assets/images/detail/back_white.png" alt="" class="back" @click="back" />
    </div>
    <div class="swiper">
      <!-- <img src="@/assets/images/detail/back_white.png" alt="" class="back" @click="back" /> -->
      <van-swipe @change="onChange">
        <van-swipe-item> <img :src="detailInfo.picUrl" alt="" class="swiper_img" /> </van-swipe-item>
        <!-- <template #indicator>
          <div class="custom-indicator">{{ current + 1 }}/5</div>
        </template> -->
      </van-swipe>
    </div>

    <div class="content">
      <div class="introduction">
        <div class="title">{{ detailInfo.name }}</div>
        <div class="tags d-f ai-c">
          <div class="tag_item">{{ detailInfo.typeName }}</div>
          <div class="tag_item">{{ detailInfo.levelName }}</div>
        </div>
        <div class="common_msg date d-f ai-c">
          <img src="@/assets/images/detail/performance/batch.png" alt="" class="icon" />
          <span>批次：{{ detailInfo.batchName }}</span>
        </div>
        <div class="common_msg d-f ai-c">
          <img src="@/assets/images/detail/performance/location.png" alt="" class="icon" />
          <span>申报地区：{{ detailInfo.areaName }}</span>
        </div>
      </div>

      <div class="introductory" v-if="detailInfo.detail">
        <div class="common_title">简介</div>
        <div class="common_text" :class="richHeight > 115 && !unfold ? 'more_text' : ''" ref="richText" v-html="detailInfo.detail"></div>
        <div class="more_btn d-f ai-c jc-fe" v-if="richHeight > 115 && !unfold" @click="unfoldText">
          <span>展开</span>
          <img src="@/assets/images/detail/more.png" class="more-img" alt="" />
        </div>
        <div class="more_btn d-f ai-c jc-fe" v-if="richHeight > 115 && unfold" @click="unfoldText">
          <span>收起</span>
          <img src="@/assets/images/detail/more_up.png" class="more-img" alt="" />
        </div>
        <!-- <div class="more">
          <div class="more-box1"></div>
          <div class="more-box" @click="expand">展开<img src="@/assets/images/detail/more.png" class="more-img" /></div>
        </div> -->
      </div>

      <!-- <div class="introductory" v-if="detailInfo.detail && expandType">
        <div class="common_title">简介</div>
        <div v-html="detailInfo.detail"></div>
      </div> -->

      <div class="inheritor" v-if="personList.length > 0">
        <div class="common_title">传承人</div>
        <div class="card_box">
          <div class="cards">
            <div class="card_item" v-for="item in personList" @click="inheritorDetail(item)">
              <!-- <img src="@/assets/images/detail/culturalCollection/img_ccr.png" alt="" class="bg" /> -->
              <div class="card_msg d-f ai-c">
                <img :src="item.picUrl" alt="" class="profile" />
                <div class="msg d-f fxd-c">
                  <span class="name">{{ item.name }}</span>
                  <div class="tags d-f ai-c">
                    <div class="tag_item profile_tag">{{ item.typeName }}</div>
                    <div class="tag_item profile_tag">{{ item.levelName }}</div>
                  </div>
                  <div class="msg_content" v-html="item.detail"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getIchProjectInfoDetails, getIchPersonByProjectId } from '@/api/intangibleCultural'
export default {
  name: 'extrageneticDirectories',
  data() {
    return { current: 0, detailInfo: {}, id: '', personList: [], expandType: false, richHeight: 0, unfold: false }
  },
  methods: {
    back() {
      this.$myUni.navigateBack({
        delta: 1,
      })
    },
    unfoldText() {
      this.unfold = !this.unfold
    },
    getDetail() {
      getIchProjectInfoDetails(this.id).then((res) => {
        this.detailInfo = res.result
        this.$nextTick(() => {
          // 高度超出115px（5行） 展示按钮
          this.richHeight = this.$refs.richText.offsetHeight
          console.log('richHeight=============>', this.richHeight)
        })
      })
    },
    removeHtmlTags(msg) {
      var msg = msg.replace(/<[^>]+>|&[^>]+;/g, '') //去除HTML Tag
      msg = msg.replace(/[|]*n/, '') //去除行尾空格
      msg = msg.replace(/&npsp;/gi, '') //去掉npsp
      return msg
    },
    getPerson() {
      getIchPersonByProjectId(this.id).then((res) => {
        this.personList = res.result
        this.personList.forEach((item) => {
          item.detail = this.removeHtmlTags(item.detail)
        })
        console.log('改过的数据=============》', this.personList)
      })
    },
    onChange(index) {
      this.current = index
    },
    inheritorDetail(item) {
      this.$router.push({
        path: '/detail/inheritor',
        query: {
          id: item.id,
        },
      })
    },
    expand() {
      this.expandType = true
    },
  },
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
    } else {
      const data = JSON.parse(this.$route.query.params)
      this.id = data.id
    }

    this.getDetail()
    this.getPerson()
  },
}
</script>
<style lang="scss" scoped>
.extrageneticDirectories {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #fff;
  .navbar {
    z-index: 9999;
    width: 100%;
    height: 44px;
    position: fixed;
    top: 40px;
    // top: calc(40px + env(safe-area-inset-top));
    left: 0;
    text-align: center;
    line-height: 44px;
    font-weight: 600;
    color: #112a26;
    font-size: 0.9rem;
    // background: #fff;
    .back {
      position: absolute;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      top: 0.5rem;
    }
  }
  .tag_item {
    font-size: 0.6rem;
    padding: 0 0.3rem;
    // color: #47988aff;

    color: #a97048;
    height: 0.9rem;
    line-height: 0.9rem;
    // background: #bedada;

    background: #f9eddc;
    border-radius: 2px;
    margin-right: 0.4rem;
    margin-top: 0.4rem;
  }
  .profile_tag {
    margin: 0.2rem 0.4rem 0.2rem 0;
  }
  .swiper {
    width: 100%;
    height: 14.1rem;
    .back {
      z-index: 1;
      position: absolute;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      top: 48px;
      // top: calc(40px + env(safe-area-inset-top));
    }
    .swiper_img {
      width: 100%;
      height: 14.1rem;
    }
    .custom-indicator {
      position: absolute;
      height: 0.95rem;
      line-height: 0.95rem;
      right: 8px;
      bottom: 0.95rem;
      padding: 0 9px;
      font-size: 0.6rem;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      border-radius: 0.5rem;
    }
  }
  .content {
    position: absolute;
    top: 13.75rem;
    left: 0;
    width: 100%;
    background: #fff;
    border-radius: 8px 8px 0px 0px;
    &::before {
      content: '';
      display: inline-block;
      width: 2rem;
      height: 5px;
      background: #cccc;
      border-radius: 3px;
      position: absolute;
      left: calc(50% - 1rem);
      top: 0.6rem;
    }
  }
  .introduction {
    padding: 1.65rem 0 0.8rem 0;
    margin: 0 0.6rem;
    border-bottom: 1px solid #f4f4f4;
    .icon {
      width: 0.7rem;
      height: 0.7rem;
      margin-right: 2px;
    }
    .title {
      font-size: 0.9rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.4rem;
    }
    .view_total {
      font-size: 0.5rem;
      color: #47988a;
      text-align: center;
      height: 0.9rem;
      line-height: 0.9rem;
      background: #dff2f2;
      border-radius: 2px;
      padding: 0 0.3rem;
    }
    .common_msg {
      font-size: 0.6rem;
      color: #666666;
      line-height: 0.8rem;
    }
    .date {
      margin: 0.6rem 0 0.3rem 0;
    }
  }
  .common_title {
    font-size: 0.8rem;
    font-weight: 600;
    color: #212121;
    line-height: 1.2rem;
    margin: 0.75rem 0 0.6rem 0;
  }
  .introductory {
    padding: 0 0.6rem;
    font-size: 0.7rem;
    color: #666666;
    line-height: 1rem;
    position: relative;
    .more {
      width: 100%;
      z-index: 999;
      position: absolute;
      top: 8.6rem;
      // left: 12.1rem;
      height: 1rem;
      display: flex;
      .more-box1 {
        width: 12.1rem;
      }
      .more-box {
        flex: 1;
        background-color: #fff;
        padding-left: 0.5rem;
        box-sizing: border-box;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #a97048;
        .more-img {
          margin-left: 0.5rem;
          width: 0.6rem;
          height: 0.6rem;
        }
      }
    }
  }
  .common_text {
    // width: 100%;
    // // height: 8rem;
    // height: auto;
    // font-size: 0.7rem;
    // font-weight: 400;
    // color: #666666;
    // // line-height: 1rem;
    // overflow: hidden; //溢出隐藏
    // white-space: pre-wrap;
    // display: -webkit-box; //
    // -webkit-box-orient: vertical; //设置弹性盒子的子元素的排列方式
    // -webkit-line-clamp: 8; //设置显示文本的行数
    &.more_text {
      height: 5.75rem;
      overflow: hidden; //溢出隐藏
    }
  }
  .more_btn {
    font-size: 0.7rem;
    color: #a97048;

    .more-img {
      margin-left: 0.5rem;
      width: 0.6rem;
      height: 0.6rem;
    }
  }
  .inheritor {
    width: 100%;
    padding: 0 0.6rem;
    padding-bottom: calc(1rem + env(safe-area-inset-bottom));

    .card_box {
      width: 100%;
      // height: 4.6rem;
      height: 4.4rem;

      overflow: hidden;
    }
    .cards {
      overflow-x: auto;
      white-space: nowrap;
      .card_item {
        position: relative;
        display: inline-block;
        width: 14.7rem;
        // height: 4.6rem;
        height: 4.4rem;

        overflow: hidden;
        margin-right: 0.7rem;
        background: rgba(169, 112, 72, 0.1);
        // border-radius: 8px;
        border-radius: 0.4rem;

        .bg {
          z-index: 0;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          // height: 100%;
          height: 4.4rem;
        }
        .card_msg {
          box-sizing: border-box;
          z-index: 1;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 4.4rem;

          // height: 100%;
          // padding: 0.8rem;
          font-size: 0.6rem;
          color: #666666;
          line-height: 0.8rem;
          .profile {
            // width: 3rem;
            // height: 3rem;
            width: 4.4rem;
            height: 4.4rem;
            border-radius: 0.4rem 0 0 0.4rem;
            // border-radius: 3rem;
            margin-right: 0.6rem;
          }
          .msg {
            flex: 1;
            padding-right: 0.3rem;
            // height: 4.4rem;
            // margin: 0.7rem 0 0.5rem 0;
            // box-sizing: border-box;
            .name {
              font-weight: 600;
              color: #212121;
              line-height: 1rem;
              font-size: 0.7rem;
              margin-top: 0.7rem;
            }
            .msg_content {
              overflow: hidden; //溢出隐藏
              white-space: pre-wrap;
              text-overflow: ellipsis; //省略号
              display: -webkit-box; //
              -webkit-box-orient: vertical; //设置弹性盒子的子元素的排列方式
              -webkit-line-clamp: 1; //设置显示文本的行数
            }
          }
        }
      }
    }
  }
}
</style>
